import { render, staticRenderFns } from "./ApproveVendor.vue?vue&type=template&id=55eaea89&scoped=true&"
import script from "./ApproveVendor.vue?vue&type=script&lang=js&"
export * from "./ApproveVendor.vue?vue&type=script&lang=js&"
import style0 from "./ApproveVendor.vue?vue&type=style&index=0&id=55eaea89&prod&scoped=true&lang=css&"
import style1 from "./ApproveVendor.vue?vue&type=style&index=1&id=55eaea89&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eaea89",
  null
  
)

export default component.exports